
import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  Chip,
  Select,
  MenuItem
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Swal from 'sweetalert2';
import { fetchmaintainers } from '../../../components/Apis';
// import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Addmaintenance from './Additem';
import Additem from './Additem';
import { Refresh } from '@mui/icons-material';
import RequestConfirmation from '../../../components/unitSuccess/Success';

const Maintenance = () => {
  const [maintainers, setmaintainers] = useState([]);
  console.log("maintainers",maintainers)
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [render ,setRender]=useState(false)
  const RenderFun=()=>{setRender(!render)}

  const fetchbroker = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we load the data.',
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await fetchmaintainers();
      setmaintainers(response.data);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      Swal.close();
    }
  };

  useEffect(() => {
    fetchbroker();
  }, [render]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  return (
    <Box sx={{ p: 3, direction: 'ltr',backgroundColor:"var(--seco-col)",height:"100vh",position:"relative",paddingTop:"4rem"}}>
      <Box sx={{ display: 'flex', justifyContent:'space-between', alignItems: 'center', mb: 3 }}>
      <Typography variant="h6">Maintenance</Typography>
      <IconButton
        onClick={handleOpen}
      >
        <AddIcon style={{ color: "var(--pri-col)", fontSize: "2rem",
              "&:hover": {
                  backgroundColor: "transparent",
                  color: "#fff",
                } }} />
      </IconButton>
      </Box>
      
      <Modal
        open={open}
        onClose={handleClose}
        // aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Additem render={RenderFun} close={handleClose}/>
        </Box>
      </Modal>



      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "#F2F4F7" }}>
            <TableRow >
              <TableCell>Number</TableCell>
              <TableCell>Unit name</TableCell>
              <TableCell>Service name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              {/* <TableCell>Price</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {maintainers?.map((record, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{record.unit_name}</TableCell>
                <TableCell>{record.service_name}</TableCell>
                <TableCell>{record.date}</TableCell>
                <TableCell>{record.status}</TableCell>
                {/* <TableCell></TableCell> */}
              </TableRow>

              // <TableRow 
              //   key={index}
              //   sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
              // >
              //   <TableCell>{record.number}</TableCell>
              //   <TableCell>{record.unitName}</TableCell>
              //   <TableCell>
              //     <Select
              //       value={record.serviceName}
              //       variant="standard"
              //       IconComponent={KeyboardArrowDownIcon}
              //       sx={{ minWidth: 120 }}
              //     >
              //       <MenuItem value={record.service_Name}>{record.serviceName}</MenuItem>
              //     </Select>
              //   </TableCell>
              //   <TableCell>{record.date}</TableCell>
              //   <TableCell>
              //     <Chip
              //       label={record.status}
              //       color={record.status === 'Paid' ? 'success' : 'error'}
              //       sx={{
              //         borderRadius: '16px',
              //         '& .MuiChip-label': {
              //           px: 2
              //         }
              //       }}
              //     />
              //   </TableCell>
              //   <TableCell>{record.price}</TableCell>
              // </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <RequestConfirmation/> */}

      <img src="../../assets/Bask 01-04 1.png" style={{width:"150px",height:"150px",position:"absolute",bottom:"0px",right:"0pc"}}/>
    </Box>
  );
}

export default Maintenance;

